import "./header.css"
import {BrowserRouter, Link} from "react-router-dom";
import "./footer.css"

export function Footer() {
    // throw new Error('I crashed!');
    return (<div className="footer">
        <div className={"footer"}><p>JustStopGambling.org is a purely educational and non-profit website to discourage house game gambling.</p></div>
    </div>)
}